import React from 'react'
import Navbar from './components/Navbar'
import ProductRow from './components/ProductRow'
import ProductTable from './components/ProductTable'
import Footer from './components/Footer'
import { t } from '../../utils/common'

function StockInContainer() {
	return (
		<div
			style={{
				marginBottom: '100px',
			}}
		>
			<Navbar title={'Stock Control'} entryType={'in'} />
			<ProductRow
				header
				item={{
					id: 0,
					item_code: t('Item Code'),
					date: t('Last Updated'),
					barcode: t('Barcode'),
					name_en: t('Name'),
					price: t('Price'),
					is_return: t('Return'),
					stock:t('Stock in'),
					expiry_date: t('Expiry Date'),
				}}
			/>
			<ProductTable />
			<Footer />
		</div>
	)
}

export default StockInContainer
